export class JamesB {
    public username: string;
    public machineUser: string;
    public remote: string;
    public server: string;
    public reason: string;
    public area: string;
    public expireDate: string;
    public isAreaBound: boolean;
    public createdAt: string;
    public updatedAt: string;
    public approved: boolean;
    
}